import { Alert, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import { getErrorMessage } from "@/shared/utils/getErrorMessage";
import type { ReportFilterState } from "../../hooks/useReportFilters";
import { useReportAnalytics } from "../../hooks/useReports";
import type { ReportKind } from "../../types";
import { resolveAnalyticsLayout } from "./analyticsLayouts";

interface Props {
	kind: ReportKind;
	filters: ReportFilterState;
}

/**
 * Hisobot sahifasining analitika bloki: konvertni so'raydi va kind
 * layout'ini chizadi.
 *
 * ⚠️⚠️ **Qog'ozga TUSHMAYDI** (`skud-no-print`) — brauzer chop etishida
 * fon ranglari tushib qoladi va diagrammalar shovqinga aylanadi
 * (`ReportDetailPage` izohi). Raqamli xulosa `ReportPrintView` da.
 *
 * ⚠️ `kind` — descriptor'dan kelgan `ReportKind`, URL dagi xom satr
 * EMAS: noma'lum kind uchun sahifa bu blokka yetib kelmaydi.
 */
export function AnalyticsSection({ kind, filters }: Props) {
	const { t } = useTranslation("reports");
	const analitika = useReportAnalytics(kind, filters, true);
	const Layout = resolveAnalyticsLayout(kind);

	return (
		<div data-testid="analytics-section" className="skud-no-print">
			{analitika.isLoading ? <Skeleton active /> : null}

			{analitika.error ? (
				<Alert
					type="error"
					showIcon
					message={getErrorMessage(analitika.error, t("detail.analyticsError"))}
				/>
			) : null}

			{analitika.data ? <Layout kind={kind} data={analitika.data} filters={filters} /> : null}
		</div>
	);
}
